var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { createContainer } from 'unstated-next';
import { useState, useEffect } from 'react';
import { storage } from '../lib/storage';
function getDefaultKana(id) {
    return {
        timesCorrect: 0,
        totalTimes: 0,
        lastSeen: new Date(),
        kanaId: id,
    };
}
function getDefaultKanaStats() {
    var kanaStats = [];
    for (var i = 0; i <= KANA_AMOUNT; i++) {
        kanaStats[i] = getDefaultKana(i);
    }
    return kanaStats;
}
var gameKey = 'game_stats';
var kanaKey = 'kana_stats';
var KANA_AMOUNT = 142;
function useStats() {
    var _a = useState([]), gameStats = _a[0], setGameStats = _a[1];
    var _b = useState(getDefaultKanaStats()), kanaStats = _b[0], setKanaStats = _b[1];
    useEffect(function () {
        function loadGameStats() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    storage.load({ key: gameKey }).then(function (res) {
                        setGameStats(res);
                    });
                    return [2 /*return*/];
                });
            });
        }
        function loadKanaStats() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    storage.load({ key: kanaKey }).then(function (res) {
                        setKanaStats(res);
                    });
                    return [2 /*return*/];
                });
            });
        }
        loadGameStats();
        loadKanaStats();
    }, []);
    useEffect(function () {
        function saveKanaStats() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    storage.save({
                        key: kanaKey,
                        data: kanaStats
                    });
                    return [2 /*return*/];
                });
            });
        }
        if (kanaStats.length < KANA_AMOUNT) {
            setKanaStats(getDefaultKanaStats());
        }
        else {
            saveKanaStats();
        }
    }, [kanaStats]);
    useEffect(function () {
        function saveGameStats() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    storage.save({
                        key: gameKey,
                        data: gameStats
                    });
                    return [2 /*return*/];
                });
            });
        }
        saveGameStats();
    }, [gameStats]);
    var add = function (game) {
        var stat = {
            correct: game.correct,
            total: game.questions.length,
            startOn: game.startedOn,
            finishedOn: game.finishedOn
        };
        setGameStats(__spreadArrays(gameStats, [stat]));
    };
    var addKana = function (kana, correct) {
        setKanaStats(function (ks) {
            var _a;
            var s = (_a = ks.find(function (s) { var _a; return ((_a = s) === null || _a === void 0 ? void 0 : _a.kanaId) === kana.id; }), (_a !== null && _a !== void 0 ? _a : getDefaultKana(kana.id)));
            var arr = Array.from(ks);
            arr[kana.id] = __assign(__assign({}, s), { lastSeen: new Date(), timesCorrect: correct ? s.timesCorrect + 1 : s.timesCorrect, totalTimes: s.totalTimes + 1 });
            return arr;
        });
    };
    var getWorstHiragana = function () {
        return kanaStats.reduce(function (p, v) {
            if (v.totalTimes === 0)
                return p;
            return (p.timesCorrect / p.totalTimes < v.timesCorrect / v.totalTimes ? p : v);
        });
    };
    var getBestHiragana = function () {
        return kanaStats.reduce(function (p, v) {
            if (v.totalTimes === 0)
                return p;
            return (p.timesCorrect / p.totalTimes > v.timesCorrect / v.totalTimes ? p : v);
        });
    };
    var getBestRow = function () {
    };
    var get = function () { return gameStats; };
    return { add: add, get: get, addKana: addKana, kanaStats: kanaStats, getBestHiragana: getBestHiragana, getWorstHiragana: getWorstHiragana, getBestRow: getBestRow };
}
export var StatsContainer = createContainer(useStats);
//# sourceMappingURL=stats.js.map